import React from 'react'
import { Container, Typography } from '@material-ui/core'
import makeStyles from '@material-ui/core/styles/makeStyles'

const useStyles = makeStyles((theme) => ({
    footer: {
        textAlign: 'center',
        marginTop: 'auto',
        color: '#222222',
        zIndex: 1,
        borderTop: '1px solid #e2e2e2',
    },
    footerTopBar: {
        maxWidth: '1440px',
        width: '100%',
        margin: '0 auto',
        padding: '1rem 1.5rem',
        textAlign: 'left',
        [theme.breakpoints.up('md')]: {
            paddingTop: '3rem',
        },
    },
    footerBottomBar: {
        padding: '0 0 1rem 0',
        [theme.breakpoints.up('md')]: {
            paddingBottom: '3rem',
        },
    },
    footerLink: {
        color: 'white',
        textDecoration: 'none',
        '&:hover': {
            textDecoration: 'underline',
        },
    },
}))

const Footer = (props) => {
    const classes = useStyles()
    return (
        <>
            <footer className={classes.footer}>
                <div className={classes.footerTopBar}>
                    <Typography>
                        ©{new Date().getFullYear()} A{' '}
                        <a
                            target="_blank"
                            rel="noopener noreferrer"
                            href={`https://www.wolfe.com/`}
                            style={{ color: '#222222' }}
                        >
                            Wolfe, LLC
                        </a>
                        {' Company '}|{' '}
                        <a href="/terms/" style={{ color: '#222222' }}>
                            Terms &amp; conditions
                        </a>{' '}
                        |{' '}
                        <a href="/privacy-policy/" style={{ color: '#222222' }}>
                            Privacy policy
                        </a>{' '}
                        |{' '}
                        <a
                            href="/refund-return-policy/"
                            style={{ color: '#222222' }}
                        >
                            Refund &amp; Return policy
                        </a>{' '}
                        |{' '}
                        <a
                            href="/cardholder-agreement/"
                            style={{ color: '#222222' }}
                        >
                            Cardholder Agreement
                        </a>
                        <br />
                        <br />
                        The Gift Card Granny Visa® Gift Card and the Digital
                        Visa Gift Card are issued by Sutton Bank®, Member FDIC,
                        pursuant to a license from Visa U.S.A. Inc. Visa is a
                        registered trademark of Visa, U.S.A. Inc. All other
                        trademarks and service marks belong to their respective
                        owners. The Visa Gift Card can be used everywhere Visa
                        debit cards are accepted in the US. No cash or ATM
                        access. The Digital Visa Gift Card can be redeemed at
                        internet merchants everywhere Visa debit cards are
                        accepted in the US. No cash or ATM access. The Gift Card
                        Granny Mastercard® Gift Card and Digital Mastercard Gift
                        Card are issued by Sutton Bank, Member FDIC, pursuant to
                        a license by Mastercard International Incorporated. Use
                        your Mastercard Gift Card and Digital Mastercard Gift
                        Card everywhere Debit Mastercard is accepted in the US.
                        Mastercard is a registered trademark, and the circles
                        design is a trademark of Mastercard International
                        Incorporated.
                    </Typography>
                </div>
            </footer>
        </>
    )
}

export default Footer
